import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Folder, Identifiable } from "@planzone/dto";
import { useMoveDocument } from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { FolderSelection } from "./folderSelection";
import { Props } from "./types";
import styles from "./styles.scss";

function MoveDocument({
  document,
  namespace,
  projectName,
  type,
  close,
}: Props) {
  const { t } = useTranslation();
  const { isRequestPending, isRequestSuccess, isRequestFailure, moveDocument } =
    useMoveDocument();
  const [selectedFolder, setSelectedFolder] =
    useState<Identifiable<Folder> | null>(null);

  return (
    <Modal
      header={t("moveDocument.title")}
      headerClassName={styles.header}
      close={close}
    >
      <div className={styles.main}>
        <div className={styles.body}>
          <FolderSelection
            namespace={namespace}
            type={type}
            selectedFolder={selectedFolder}
            placeholder={t("moveDocument.placeholder")}
            projectName={projectName}
            select={(folder) => setSelectedFolder(folder)}
          />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={close}>
            {t("moveDocument.cancel")}
          </Button>
          <Button
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            press={() => {
              selectedFolder &&
                moveDocument({
                  document,
                  // @ts-ignore
                  from: document.parentUuid,
                  to: selectedFolder.uuid,
                });
            }}
          >
            {t("moveDocument.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { MoveDocument };
